import { Component, Input, Output, OnInit, EventEmitter, ChangeDetectionStrategy, Inject } from '@angular/core';
import { NgClass, NgIf, CurrencyPipe, DatePipe } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { FuseCardComponent } from '@fuse/components/card';
import { TFMService } from 'app/mock-api/tfm.service';
import { TFMCartService } from 'app/mock-api/tfm-cart.service';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { StayListComponent } from '../list-stay/stay-list.component';

@Component({
  selector: 'stay-list-dialog',
  standalone: true,
  imports: [NgIf,StayListComponent],
  providers: [TFMService],
  templateUrl: './stay-list-dialog.component.html',
  styleUrl: './stay-list-dialog.component.scss',
  changeDetection: ChangeDetectionStrategy.Default
})
export class StayListDialogComponent implements OnInit {

  public view : any = {

  }
  /**
   * Constructor
   */
  constructor(private _tfmService : TFMService, private _tfmCartService: TFMCartService, public dialogRef: MatDialogRef<StayListDialogComponent>, @Inject(MAT_DIALOG_DATA) public data: any)
  {
    this.view.search = data.search;
    this.view.trip = data.trip;
  }

  /**
  * On init
  */
  ngOnInit(): void {
    
    this._tfmService.log("stayList", this.view);
  }
}
